import reducer from './reducers';

export { default as floorsSelectors } from './selectors';
export { default as floorsOperations } from './operations';
export { default as floorsTypes } from './types';
export { default as normalizeData } from './schema';

export default reducer;
